import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../wayfinder'
/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: '/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Cases\GetCases::__invoke
* @see app/Actions/Cases/GetCases.php:17
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Cases\GetCases::__invoke
* @see app/Actions/Cases/GetCases.php:17
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Cases\GetCases::__invoke
* @see app/Actions/Cases/GetCases.php:17
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Cases\GetCases::__invoke
* @see app/Actions/Cases/GetCases.php:17
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Pages\GetPrivacy::__invoke
* @see app/Actions/Pages/GetPrivacy.php:17
* @route '/privacy'
*/
export const privacy = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

privacy.definition = {
    methods: ["get","head"],
    url: '/privacy',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Pages\GetPrivacy::__invoke
* @see app/Actions/Pages/GetPrivacy.php:17
* @route '/privacy'
*/
privacy.url = (options?: RouteQueryOptions) => {
    return privacy.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Pages\GetPrivacy::__invoke
* @see app/Actions/Pages/GetPrivacy.php:17
* @route '/privacy'
*/
privacy.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Pages\GetPrivacy::__invoke
* @see app/Actions/Pages/GetPrivacy.php:17
* @route '/privacy'
*/
privacy.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: privacy.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Pages\GetFeedback::__invoke
* @see app/Actions/Pages/GetFeedback.php:17
* @route '/feedback'
*/
export const feedback = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: feedback.url(options),
    method: 'get',
})

feedback.definition = {
    methods: ["get","head"],
    url: '/feedback',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Pages\GetFeedback::__invoke
* @see app/Actions/Pages/GetFeedback.php:17
* @route '/feedback'
*/
feedback.url = (options?: RouteQueryOptions) => {
    return feedback.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Pages\GetFeedback::__invoke
* @see app/Actions/Pages/GetFeedback.php:17
* @route '/feedback'
*/
feedback.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: feedback.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Pages\GetFeedback::__invoke
* @see app/Actions/Pages/GetFeedback.php:17
* @route '/feedback'
*/
feedback.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: feedback.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Profile\GetProfile::__invoke
* @see app/Actions/Profile/GetProfile.php:17
* @route '/profile'
*/
export const profile = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: profile.url(options),
    method: 'get',
})

profile.definition = {
    methods: ["get","head"],
    url: '/profile',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Profile\GetProfile::__invoke
* @see app/Actions/Profile/GetProfile.php:17
* @route '/profile'
*/
profile.url = (options?: RouteQueryOptions) => {
    return profile.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Profile\GetProfile::__invoke
* @see app/Actions/Profile/GetProfile.php:17
* @route '/profile'
*/
profile.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: profile.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Profile\GetProfile::__invoke
* @see app/Actions/Profile/GetProfile.php:17
* @route '/profile'
*/
profile.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: profile.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Answers\GetMyResults::__invoke
* @see app/Actions/Answers/GetMyResults.php:17
* @route '/results'
*/
export const results = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: results.url(options),
    method: 'get',
})

results.definition = {
    methods: ["get","head"],
    url: '/results',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Answers\GetMyResults::__invoke
* @see app/Actions/Answers/GetMyResults.php:17
* @route '/results'
*/
results.url = (options?: RouteQueryOptions) => {
    return results.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Answers\GetMyResults::__invoke
* @see app/Actions/Answers/GetMyResults.php:17
* @route '/results'
*/
results.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: results.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Answers\GetMyResults::__invoke
* @see app/Actions/Answers/GetMyResults.php:17
* @route '/results'
*/
results.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: results.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Admin\GetAnswerScoringQueue::__invoke
* @see app/Actions/Admin/GetAnswerScoringQueue.php:17
* @route '/scoring'
*/
export const scoring = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: scoring.url(options),
    method: 'get',
})

scoring.definition = {
    methods: ["get","head"],
    url: '/scoring',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Admin\GetAnswerScoringQueue::__invoke
* @see app/Actions/Admin/GetAnswerScoringQueue.php:17
* @route '/scoring'
*/
scoring.url = (options?: RouteQueryOptions) => {
    return scoring.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\GetAnswerScoringQueue::__invoke
* @see app/Actions/Admin/GetAnswerScoringQueue.php:17
* @route '/scoring'
*/
scoring.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: scoring.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Admin\GetAnswerScoringQueue::__invoke
* @see app/Actions/Admin/GetAnswerScoringQueue.php:17
* @route '/scoring'
*/
scoring.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: scoring.url(options),
    method: 'head',
})

